import React, { useEffect, useState } from 'react'
import classes from "./SubscribePage.module.css";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { loginApi } from '../Http/http';

const LoginPage = () => {
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [extRef, setExtRef] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (Cookies.get("msisdn")) {
      navigate("/home");
    }
  }, []);

  useEffect(() => {
    if (searchParams.get("ext_id")) {
      setExtRef(searchParams.get("ext_id"));
    } else {
      setSearchParams({ ext_id: uuidv4() });
    }
  }, [searchParams]);

  const handleFormSubmission = async (e) => {
    try {
      e.preventDefault();
      if (msisdn?.trim().length == 0) {
        return;
      }
      setLoading(true);

      let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

      if (msisdnWithCountryCode.startsWith('0')) {
        msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
      }

      if (!msisdnWithCountryCode.startsWith('94')) {
        msisdnWithCountryCode = '94' + msisdnWithCountryCode;
      }

      const response = await loginApi(msisdnWithCountryCode);
      console.log(response, 'response');
      Cookies.set("msisdn", msisdnWithCountryCode, { expires: 1 });
      setLoading(false);
      toast.success("Login Successfully!");
      navigate("/home");
    } catch (error) {
      setLoading(false);
      console.log(error?.response?.data?.error?.status, 'error');
      if (error?.response?.data?.error?.status == 0) {
        toast.error("You are not Subscribed!");
      }
      else if (error?.response?.data?.error?.status == 1) {
        toast.error("You have not been charged!");
      }
      else {
        toast.error("Something Went Wrong! Try Again!");
      }
    }
  }

  return (
    <main className={classes.main}>
      <div className={classes.container}>
        <h1 className={classes.portalDescription}>Games Dal</h1>

        <div className={classes.landingPageBanner}>
          <img src="assets/images/banner.gif" alt="Banner" className={classes.banner} />
        </div>

        <div className={classes.actions_box_container}>
          <div className={classes.actions_box}>
            <button type="button" className={`${classes.action_box} ${classes.active}`}
            >
              Login
            </button>
            <button type="button" className={`${classes.action_box} ${classes.active}`}
              onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
            >
              Subscribe
            </button>
          </div>
        </div>

        <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
          className={classes.input}
        />

        <button className={classes.subscribeBtn} id="subscribe_btn"
          onClick={handleFormSubmission}
          disabled={loading}
        >
          {loading ? "Login..." : (
            <>
              Login <img src="/assets/images/lock.png" alt="lock" className={classes.lockImg} />
            </>
          )}
        </button>

      </div >
    </main >
  )
}

export default LoginPage